import { useInventoryPaginationContext } from "domain/Inventory/context";
import React from "react";
import { Button } from "shared";
import "./NoResultsForPageComponent.scss";

export const NoResultsForPageComponent = () => {
  const { handlePageChange } = useInventoryPaginationContext();

  return (
    <div className="no-results-page">
      <h2 className="no-results-page__title">Nema rezultata na ovoj stranici</h2>
      <p className="no-results-page__text">
        Stranica koju ste zatražili je prazna. Moguće je da ste pratili stari ili nevažeći link.
      </p>
      <div className="no-results-page__button">
        <Button buttonText={"Idi na prvu stranu"} buttonColor={"blue"} event={() => handlePageChange(1)} />
      </div>
    </div>
  );
};
